module.exports = function sanitizeKilogramms(kilogramms) {
    return Math.ceil(kilogramms * 10) / 10;
};
